import { createRoot } from 'react-dom/client';
import { App } from './components/App';
import { registerAllPuzzles } from './puzzles/registry';
import { initAnalyticsSubscription } from './analytics/storeSubscription';
import './styles/global.css';

registerAllPuzzles();
initAnalyticsSubscription();

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(<App />);
}
